export class Changepassword {
    UserId:number;
    Password:string;
    OldPassword:string;
}

